export const GTM_EVENTS = {
  genericEventStep: 'generic_event_step',
  genericEventConv: 'generic_event_conv',
  genericEventAction: 'generic_event_action',
};

export const GTM_CATEGORIES = {
  suppliersRegistration: 'suppliers_registration',
  conversion: 'conversion',
  supplierActions: 'supplier_actions',
};

export const GTM_ACTIONS = {
  registrationStart: 'registration_start',
  namePhonePass: 'name_phone_pass',
  businessInfo: 'business_info',
  lead: 'lead',
  userCreated: 'user_created',
  submitInfoToReview: 'submit_info_to_review',
  connectedStore: 'connected_store',
  activateProducts: 'activate_products',
  updateSettings: 'update_settings',
};

export const GTM_REGISTRATION_VIEW_STEP_ONE = {
  event: GTM_EVENTS.genericEventStep,
  category: GTM_CATEGORIES.suppliersRegistration,
  action: GTM_ACTIONS.registrationStart,
};

export const GTM_REGISTRATION_VIEW_STEP_TWO = {
  event: GTM_EVENTS.genericEventStep,
  category: GTM_CATEGORIES.suppliersRegistration,
  action: GTM_ACTIONS.namePhonePass,
};

export const GTM_VIEW_TELL_US_MODAL = {
  event: GTM_EVENTS.genericEventStep,
  category: GTM_CATEGORIES.suppliersRegistration,
  action: GTM_ACTIONS.businessInfo,
};

export const GTM_REGISTRATION_EMAIL = {
  event: GTM_EVENTS.genericEventConv,
  category: GTM_CATEGORIES.conversion,
  action: GTM_ACTIONS.lead,
};

export const GTM_REGISTRATION_USER_CREATED = {
  event: GTM_EVENTS.genericEventConv,
  category: GTM_CATEGORIES.conversion,
  action: GTM_ACTIONS.userCreated,
};

export const GTM_SUBMIT_FOR_REVIEW = {
  event: GTM_EVENTS.genericEventConv,
  category: GTM_CATEGORIES.conversion,
  action: GTM_ACTIONS.submitInfoToReview,
};

export const GTM_CONNECTED_STORE = {
  event: GTM_EVENTS.genericEventAction,
  category: GTM_CATEGORIES.supplierActions,
  action: GTM_ACTIONS.connectedStore,
};

export const GTM_ACTIVATE_PRODUCTS = {
  event: GTM_EVENTS.genericEventAction,
  category: GTM_CATEGORIES.supplierActions,
  action: GTM_ACTIONS.activateProducts,
};

export const GTM_UPDATE_SETTINGS = {
  event: GTM_EVENTS.genericEventAction,
  category: GTM_CATEGORIES.supplierActions,
  action: GTM_ACTIONS.updateSettings,
};
